// 文字数カウンター
// data-char-limit="上限" を持つ入力欄の下の行（.c-field-footer）の右端に「現在の文字数/上限字」を表示する。
// 入力自体は止めず（既存データをそのまま表示するため）、超過時はカウンターを赤くする。
// 超過の送信を止める処理とエラー表示は form_errors.js にある。
import { FIELD_SELECTOR, COUNTER_CLASS, countChars, charLimitOf, childOfFooter } from '../lib/char_limit';

const counterFor = function(field) {
  return childOfFooter(field, COUNTER_CLASS);
};

// 勤務先名のように入力欄が親より狭い場合、フッター行を入力欄の幅に揃えてカウンターを入力欄の右下に合わせる。
// 入力欄が非表示（幅0）のときは指定しない（表示されて入力されたときに揃う）。
const alignFooterWidth = function(field, footer) {
  const width = field.offsetWidth;
  const maxWidth = width > 0 ? width + 'px' : '';
  if (footer.style.maxWidth !== maxWidth) footer.style.maxWidth = maxWidth;
};

const updateCounter = function(field) {
  const limit = charLimitOf(field);
  const count = countChars(field.value);
  const counter = counterFor(field);
  const text = count + '/' + limit + '字';

  // MutationObserver の無限ループを避けるため、変化がない場合は DOM を触らない
  if (counter.textContent !== text) counter.textContent = text;
  counter.classList.toggle('-over', count > limit);
  alignFooterWidth(field, counter.parentElement);
};

const updateCountersIn = function(root) {
  if (root.matches(FIELD_SELECTOR)) updateCounter(root);
  root.querySelectorAll(FIELD_SELECTOR).forEach(updateCounter);
};

document.addEventListener('input', function(event) {
  if (event.target.matches && event.target.matches(FIELD_SELECTOR)) updateCounter(event.target);
});

// 画面幅で入力欄の幅が変わるため、リサイズ時にフッター行の幅を合わせ直す
window.addEventListener('resize', function() {
  updateCountersIn(document.body);
});

document.addEventListener('DOMContentLoaded', function() {
  updateCountersIn(document.body);

  // Vue で後から追加される行（職務経歴・語学の追加など）にもカウンターを付ける
  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) updateCountersIn(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
